import React, { useEffect, useMemo, useRef, useState } from "react";
import trash from "../../../../../assets/restaurant/images/trash.svg";
import { list, add, deleteTable, edit, detail, listAllFloorTables, rearrangeFloorTables, getTableNumber } from "../../../services/table.service";
import { LOADER_TIMEOUT_TIME, ORDER_STATUS, QR_CODE_TYPES, ROLE, SOCKET_EVENTS, SWAL_SETTINGS, TABLE_BORDER_COLOR, TABLE_FILL_COLOR, TABLE_TEXT_COLOR } from "../../../../../utils/Constants";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import { useValidationSchemas } from "../../../validator/validation";
import { useTranslation } from "react-i18next";
import { globalLoader, handleOffcanvasScroll, handleServerValidations, useDebouncing, capitalizeFirstLetter, TrimText, generateTablePdf, blockSpecialChar, DT, getUserData } from "../../../../../utils/commonfunction";
import { TABLE_SHAPE_TYPES } from "../../../../../utils/Constants";
import CustomError from "../../../../../utils/customError";
import { Link, useNavigate, useParams } from "react-router-dom";
import RecordNotFound from "../../../shared/recordNotFound";
import { Drawer } from "rsuite";
import Skeleton from "react-loading-skeleton";
import ReactToPrint from "react-to-print";
import { QRCodeSVG } from "qrcode.react";
import { SOCKET_CLIENT } from "../../../../../utils/socket";
import CustomPagination from "../../../../admin/common/custompagination";
//canvas
import { Canvas, Rect, Circle, Text, Group } from 'fabric';

export default function Tables() {
  const params = useParams();
  const { t } = useTranslation();
  const [List, setList] = useState([]);
  const { tableValidationSchema } = useValidationSchemas();
  const [refreshList, setRefreshList] = useState(false);
  const [openWithHeader, setOpenWithHeader] = useState(false);
  const [openWithHeaderEdit, setOpenWithHeaderEdit] = useState(false);
  const [globalSearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});
  const [loader, setLoader] = useState(true);
  const [statusFilter, setStatusFilter] = useState(null);
  const [tableDetail, setTableDetail] = useState({});
  const [page, setPage] = useState(1);
  const [offset, setOffsetPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [itemPerPage] = useState(12);
  const [prevGlobalSearch, setPrevGlobalSearch] = useState("");
  const navigate = useNavigate();
  const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
  const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);
  const [newTableNumber, setNewTableNumber] = useState(0);
  const [refreshTableNumber, setRefreshTableNumber] = useState("");

  //canvas
  const canvasRef = useRef(null);
  const canvasRef2 = useRef(null);
  const floorPlanModalCloseBtn = useRef(null);
  const [canvas, setCanvas] = useState(null);
  const [initializeCanvas, setInitializeCanvas] = useState(true);
  const [floorTablesObj, setFloorTablesObj] = useState(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    // Create canvas instance
    const initCanvas = new Canvas(canvasRef.current, {
      width: 1100,
      height: 600,
    });

    canvasRef2.current = initCanvas;
    // Disable multi-select
    initCanvas.selection = false;
    initCanvas.selectionKey = null;
    initCanvas.fireRightClick = false;
    initCanvas.stopContextMenu = true;

    // Cleanup multiple-selection
    const forceSingleSelection = (e) => {
      if (e.selected && e.selected.length > 1) {
        const last = e.selected[e.selected.length - 1];
        initCanvas.discardActiveObject();
        initCanvas.setActiveObject(last);
      }
    };

    initCanvas.on("selection:created", forceSingleSelection);
    initCanvas.on("selection:updated", forceSingleSelection);

    // initCanvas.backgroundColor = "#fff";
    initCanvas.renderAll();
    setCanvas(initCanvas);

    // Collision helpers
    const getRect = (obj) => obj.getBoundingRect(true);
    const COLLISION_BUFFER = 1;

    // Track last pointer position (for direction)
    let lastPointer = { x: 0, y: 0 };

    initCanvas.on("mouse:move", (e) => {
      if (e.pointer) {
        lastPointer.x = e.pointer.x;
        lastPointer.y = e.pointer.y;
      }
    });

    // Drag collision handler
    const handleMoving = (e) => {
      const obj = e.target;
      const canvasW = initCanvas.width;
      const canvasH = initCanvas.height;

      if (!obj._lastValid) {
        obj._lastValid = { left: obj.left, top: obj.top };
      }

      const rect = getRect(obj);
      const w = rect.width;
      const h = rect.height;

      // Keep object inside canvas
      if (obj.left < 0) obj.left = 0;
      if (obj.top < 0) obj.top = 0;
      if (obj.left + w > canvasW) obj.left = canvasW - w;
      if (obj.top + h > canvasH) obj.top = canvasH - h;

      const others = initCanvas.getObjects().filter((o) => o !== obj);

      // Movement delta
      const dx = obj.left - obj._lastValid.left;
      const dy = obj.top - obj._lastValid.top;

      const movingRight = dx > 0;
      const movingLeft = dx < 0;
      const movingDown = dy > 0;
      const movingUp = dy < 0;

      let blockingOverlap = false;

      for (const other of others) {
        const oRect = getRect(other);

        const overlap =
          rect.left < oRect.left + oRect.width - COLLISION_BUFFER &&
          rect.left + rect.width - COLLISION_BUFFER > oRect.left &&
          rect.top < oRect.top + oRect.height - COLLISION_BUFFER &&
          rect.top + rect.height - COLLISION_BUFFER > oRect.top;

        if (overlap) {
          // Are we moving INTO another object?
          const movingInto =
            (movingRight && rect.left < oRect.left) ||
            (movingLeft && rect.left > oRect.left) ||
            (movingDown && rect.top < oRect.top) ||
            (movingUp && rect.top > oRect.top);

          if (movingInto) {
            blockingOverlap = true;
          }
        }
      }

      if (blockingOverlap) {
        // Snap back only if dragging INTO collision
        obj.left = obj._lastValid.left;
        obj.top = obj._lastValid.top;
      } else {
        // Allow movement (dragging away or no overlap)
        obj._lastValid.left = obj.left;
        obj._lastValid.top = obj.top;
      }

      obj.setCoords();
      initCanvas.requestRenderAll();
    };

    // On mouse down, freeze last safe position
    const handleMouseDown = (e) => {
      const target = e.target;
      if (target) {
        target._lastValid = { left: target.left, top: target.top };
      }
    };

    // Attach listeners
    initCanvas.on("object:moving", handleMoving);
    initCanvas.on("mouse:down", handleMouseDown);

    // Cleanup
    return () => {
      initCanvas.off("object:moving", handleMoving);
      initCanvas.off("mouse:down", handleMouseDown);
      initCanvas.off("selection:created", forceSingleSelection);
      initCanvas.off("selection:updated", forceSingleSelection);
      initCanvas.dispose();
    };
  }, [initializeCanvas]);



  function isOverlapping(newObj, canvas) {
    return canvas.getObjects().some(obj => {
      // console.log(obj.left, obj.top, obj.height, obj.)
      if (obj === newObj) return false; // Ignore itself

      // Check if bounding boxes overlap
      return !(
        newObj.left + newObj.width < obj.left ||  // New shape is left of existing shape
        newObj.left > obj.left + obj.width ||  // New shape is right of existing shape
        newObj.top + newObj.height < obj.top ||  // New shape is above existing shape
        newObj.top > obj.top + obj.height  // New shape is below existing shape
      );
    });
  }

  const addRectangle = (table) => {
    if (!canvas) return;

    const isOccupied = !table.is_available;

    const rect = new Rect({
      top: table.top,
      left: table.left,
      width: table.width,
      height: table.height,
      fill: TABLE_FILL_COLOR,
      rx: 8,
      ry: 8,
      stroke: TABLE_BORDER_COLOR,
      strokeWidth: 1,
      strokeDashArray: [6, 6],
      ...(isOccupied ? {} : {}),

    });

    // Prevent overlapping placement
    let attempts = 0;
    while (isOverlapping(rect, canvas) && attempts <= 1925) {
      if (rect.left + rect.width + 20 > 1100) {
        if (rect.top + rect.height > 700) break;
        rect.left = 0;
        rect.top += 20;
      } else {
        rect.left += 20;
      }
      attempts++;
    }

    // 🧠 Calculate allowed characters dynamically based on rectangle width
    const avgCharWidth = table.table_text_font_size * 0.6; // rough avg width per character
    const maxChars = Math.floor(rect.width / avgCharWidth);
    const displayText = TrimTableNumber(table.table_number, maxChars);
    const text = new Text(displayText, {
      top: rect.top + rect.height / 2.0,
      left: rect.left + rect.width / 2.0,
      fontSize: table.table_text_font_size,
      fill: TABLE_TEXT_COLOR,
      fontWeight: "bold",
      originX: "center",
      originY: "center",
      // opacity: isOccupied ? 0.3 : 1,
    });

    const group = new Group([rect, text], {
      table_id: table._id,
      shape: table.shape,
      // selectable: !isOccupied,
      // hasControls: !isOccupied,
      // lockMovementX: isOccupied,
      // lockMovementY: isOccupied,
    });

    group.setControlsVisibility({
      mt: false,
      mb: false,
      ml: false,
      mr: false,
      mtr: true,
    });

    // 🧩 Handle font size dynamically on resize/scaling
    group.on("scaling", function () {
      const newFontSize = Math.min(
        table.table_text_font_size,
        (table.height + table.width) / 2
      );
      text.set({ fontSize: newFontSize });
      group.setCoords();
    });

    canvas.add(group);
  };

  const addCircle = (table) => {
    if (!canvas) return;

    const isOccupied = !table.is_available;

    const circle = new Circle({
      top: table.top,
      left: table.left,
      radius: table.radius,
      fill: TABLE_FILL_COLOR,
      stroke: TABLE_BORDER_COLOR,
      strokeWidth: 1,
      strokeDashArray: [6, 6],
    });

    // Prevent overlapping placement
    let attempts = 0;
    while (isOverlapping(circle, canvas) && attempts < 1925) {
      if (circle.left + circle.width + 20 > 1100) {
        if (circle.top + circle.height > 700) break;
        circle.left = 0;
        circle.top += 20;
      } else {
        circle.left += 20;
      }
      attempts++;
    }

    // 🧮 Dynamically calculate allowed characters based on circle diameter
    const diameter = circle.radius * 2;
    const avgCharWidth = table.table_text_font_size * 0.6; // approx per-character width
    const maxChars = Math.floor(diameter / avgCharWidth);
    const displayText = TrimText(table.table_number, maxChars);

    const text = new Text(displayText, {
      top: circle.top + circle.radius,
      left: circle.left + circle.radius,
      fontSize: table.table_text_font_size,
      fill: TABLE_TEXT_COLOR,
      fontWeight: "bold",
      originX: "center",
      originY: "center",
      // opacity: isOccupied ? 0.3 : 1,
    });

    const group = new Group([circle, text], {
      table_id: table._id,
      shape: table.shape,
      // selectable: !isOccupied,
      // hasControls: !isOccupied,
      // lockMovementX: isOccupied,
      // lockMovementY: isOccupied,
    });

    group.setControlsVisibility({
      mt: false,
      mb: false,
      ml: false,
      mr: false,
      mtr: true,
    });

    // 🧩 Adjust text dynamically on scaling
    group.on("scaling", function () {
      const newFontSize = Math.min(table.table_text_font_size, table.radius);
      text.set({ fontSize: newFontSize });
      group.setCoords();
    });

    canvas.add(group);
  };

  const checkOverlaps = () => {
    const canvas = canvasRef2.current;
    if (!canvas) return false;

    const overlappingShapes = [];
    const objects = canvas.getObjects();
    const GAP = 5; // allowed space in px

    for (let i = 0; i < objects.length; i++) {
      const objA = objects[i];
      const rectA = objA.getBoundingRect(true);

      // Shrink rectA by GAP
      const a = {
        left: rectA.left + GAP,
        right: rectA.left + rectA.width - GAP,
        top: rectA.top + GAP,
        bottom: rectA.top + rectA.height - GAP,
      };

      for (let j = i + 1; j < objects.length; j++) {
        const objB = objects[j];
        const rectB = objB.getBoundingRect(true);

        // Shrink rectB by GAP
        const b = {
          left: rectB.left + GAP,
          right: rectB.left + rectB.width - GAP,
          top: rectB.top + GAP,
          bottom: rectB.top + rectB.height - GAP,
        };

        const isOverlapping = !(
          a.right <= b.left ||
          a.left >= b.right ||
          a.bottom <= b.top ||
          a.top >= b.bottom
        );

        if (isOverlapping) {
          overlappingShapes.push([objA, objB]);
        }
      }
    }

    return overlappingShapes.length > 0;
  };

  // ✂️ Helper to safely trim text with ellipsis if needed
  function TrimTableNumber(text, maxChars) {
    if (text.length <= maxChars) return text;
    return text.slice(0, maxChars - 1) + "…";
  }

  const clearCanvas = () => {
    if (canvas) {
      canvas.dispose();        // fully destroy Fabric instance
    }

    // Reset the DOM manually
    const el = canvasRef.current;
    if (el) {
      el.width = 1100;
      el.height = 700;
      el.getContext("2d").clearRect(0, 0, el.width, el.height);
    }

    setCanvas(null);
  };

  const handleOpenFloorPlanModal = () => {
    const userData = getUserData(ROLE.RESTAURANT);
    listAllFloorTables(userData._id)
      .then((data) => {
        if (data && data.data) {
          const tablesObj = {};

          data.data.forEach((table) => {
            if (table.shape == 'rectangle' || table.shape == 'square') {
              addRectangle(table)
            } else if (table.shape == 'round') {
              addCircle(table)
            }
            tablesObj[table._id] = table;
          })

          setFloorTablesObj(tablesObj);
        }
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });

  };

  const handleCloseFloorPlanModal = () => {
    if (checkOverlaps()) {
      Swal.fire({
        icon: "error",
        text: "Tables are overlapping. Please adjust the positions.",
        ...SWAL_SETTINGS,
      });
      return;
    }
    let floorTablesRearranged = [];
    canvas.forEachObject((obj) => {

      if (obj.shape == 'rectangle' || obj.shape == 'square') {
        floorTablesRearranged.push({
          _id: obj.table_id,
          top: obj.top,
          left: obj.left,
          width: floorTablesObj[obj.table_id].width * obj.scaleX,
          height: floorTablesObj[obj.table_id].height * obj.scaleX,
          shape: obj.shape,
          table_text_font_size: obj._objects[1].fontSize * obj.scaleX
        })
      } else {
        floorTablesRearranged.push({
          _id: obj.table_id,
          top: obj.top,
          left: obj.left,
          radius: floorTablesObj[obj.table_id].radius * obj.scaleX,
          shape: obj.shape,
          table_text_font_size: obj._objects[1].fontSize * obj.scaleX
        })
      }
    });

    setInitializeCanvas(!initializeCanvas);

    const formData = new FormData();
    formData.append('floor_tables', JSON.stringify(floorTablesRearranged));
    rearrangeFloorTables(formData).then((response) => {
      Swal.fire({
        icon: "success",
        text: response?.message,
        ...SWAL_SETTINGS,
      });
      floorPlanModalCloseBtn?.current?.click();
      canvas.clear();
      // canvas.requestRenderAll();
    }).catch((error) => {
      console.log(error);
    });
  };

  useMemo(() => {
    SOCKET_CLIENT.on("GET-DATA", (response) => {
      const eventData = response.data;

      /** Marking the table as unavailable if the order is placed */
      if (response.event === SOCKET_EVENTS.ORDER_PLACED) {
        let tableList = [...List];
        const index = tableList.findIndex((item) => item._id === eventData.table_id);
        if (index !== -1) {
          tableList[index].is_available = [ORDER_STATUS.COMPLETED, ORDER_STATUS.CANCELLED].includes(eventData.status);
          setList(tableList);
        }
      }

      /** Marking the table as available if the order is billed or cancelled */
      if (response.event === SOCKET_EVENTS.ORDER_BILLED || response.event === SOCKET_EVENTS.ORDER_CANCELLED) {
        let tableList = [...List];
        const index = tableList.findIndex((item) => item._id === eventData.table_id);
        if (index !== -1) {
          tableList[index].is_available = true;
          setList(tableList);
        }
      }
    });
  }, [List]);

  const prepareGlobalSearch = (value) => {
    setGlobalSearch(value);
  };
  const searchDebounce = useDebouncing(prepareGlobalSearch);

  useEffect(() => {
    setLoader(true);
    const formData = new FormData();
    if (Object.keys(search).length) {
      formData.append("search", JSON.stringify(search));
    }
    if (statusFilter) {
      formData.append("is_available", statusFilter);
    }
    formData.append("global_search", globalSearch);
    // Determine the page number
    let page = params.page;
    if (globalSearch) {
      if (prevGlobalSearch !== globalSearch || !prevGlobalSearch) {
        page = 1; // Reset to the first page if globalSearch changes
      }
      setPage(page);
    }
    formData.append("page", page);
    formData.append("per_page", itemPerPage);

    list(formData)
      .then((data) => {
        if (data && data.data) {
          setList(data.data.list || []);
          setPage(data.data.page);
          navigate(`/restaurant/table-management/table/${data.data.page}`);
          setOffsetPage(data.data.offset);
          setTotalRecords(data.data.total_records || 0);
          findReservedTables(data.data.list || []);
        } else {
          setList([]);
          setOffsetPage(0);
          setTotalRecords(0);
        }

        setPrevGlobalSearch(globalSearch);

        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
      })
      .catch((error) => {
        console.log("error ====> ", error);
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
      });
  }, [search, refreshList, globalSearch, params.page, statusFilter]);

  const getTableDetail = (item) => {
    detail({ o_id: item._id })
      .then((response) => {
        editTableForm.setValues({
          o_id: item._id,
          table_number: item.table_number,
          capacity: item.capacity,
          shape: item.shape,
        });
        setTableDetail(response?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addForm = useFormik({
    initialValues: {
      table_number: "",
      capacity: "",
      shape: "",
    },
    validationSchema: tableValidationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("table_number", values.table_number);
      formData.append("capacity", values.capacity);
      formData.append("shape", values.shape);
      setAddSubmissionLoader(true);
      add(formData)
        .then((response) => {
          setAddSubmissionLoader(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm();
            setOpenWithHeader(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setAddSubmissionLoader(false);
          console.error("Error adding table", error);
        });
    },
  });

  const editTableForm = useFormik({
    initialValues: {
      o_id: tableDetail._id,
      table_number: tableDetail.table_number,
      capacity: tableDetail.capacity,
      shape: tableDetail.shape,
    },
    validationSchema: tableValidationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      let obj = {
        o_id: tableDetail._id,
        table_number: values.table_number,
        capacity: values.capacity,
        shape: values.shape,
      };
      setEditSubmissionLoader(true);
      edit(obj)
        .then((response) => {
          setEditSubmissionLoader(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm();
            setOpenWithHeaderEdit(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setEditSubmissionLoader(false);
          console.error("Error updating table", error);
        });
    },
  });

  const deleteRecord = (item) => {
    Swal.fire({
      title: t("restaurant.table_management.msg_are_you_sure"),
      text: t("restaurant.table_management.btn_delete_text"),
      imageUrl: trash,
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("restaurant.table_management.btn_delete"),
      cancelButtonText: t("restaurant.table_management.btn_cancel"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        globalLoader(true);
        deleteTable({ o_id: item._id })
          .then((response) => {
            globalLoader(false);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setRefreshList(!refreshList);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            globalLoader(false);
            console.log("deleteError");
          });
      } else {
        // setSortableCategories(List);
      }
    });
  };

  const componentRef = useRef();

  const handelDownload = (fileName = "qrCode.pdf") => {
    generateTablePdf(fileName);
  };
  const getLabelByValue = (value) => {
    const item = TABLE_SHAPE_TYPES.find((shapeType) => shapeType.value === value);
    return item ? item.label : "";
  };

  const generateQRUrl = (tableDetail) => {
    let qrCodeData = {
      restaurant_id: tableDetail.restaurant_id,
      table_id: tableDetail._id,
      type: QR_CODE_TYPES.TABLE,
      base: "web",
    };
    const queryString = new URLSearchParams(qrCodeData).toString();
    let url = `${process.env.REACT_APP_WEB_BASE_URL}/qr-order?${queryString}`;
    return url;
  };

  const findReservedTables = (List) => {
    if (List.length) {
      // setTimeout(() => {
      let allTables = [...List];
      List.forEach((table, index) => {
        if (table?.reservations?.length) {
          let is_reserved = false;
          for (let i = 0; i < table?.reservations?.length; i++) {
            const reservation = table?.reservations[i];
            const startDate = new Date(reservation?.start_time).getTime();
            const endDate = new Date(reservation?.end_time).getTime();
            const currentTime = new Date().getTime();
            if (currentTime >= startDate && currentTime < endDate) {
              is_reserved = true;
              break;
            } else {
              is_reserved = false;
            }
          }
          allTables[index].is_reserved = is_reserved;
        }
      });
      setList(allTables);
      // }, 5000);
    }
  };

  useMemo(() => {
    if (refreshTableNumber !== "") {
      getTableNumber()
        .then((response) => {
          if (response && response.data) {
            setNewTableNumber(response?.data?.tableNumber || 0);
          }
        })
        .catch((error) => {
          console.log("error ====> ", error);
        });
    }
  }, [refreshTableNumber]);


  return (
    <>
      <main id="main-content">
        <div className="inner-container">
          <div className="page-header d-flex align-items-center">
            <h4 className="heading-title-text">{t("restaurant.table_management.label_tables")} </h4>
          </div>
          <div className="card-outer-header d-flex justify-content-between align-items-center mb-4">
            <div className="search-box">
              <input
                type="text"
                className="form-control search-input"
                placeholder={t("restaurant.table_management.input_placeholder_search")}
                onInput={(e) => {
                  searchDebounce(e.target.value);
                }}
              />
            </div>
            <div className="card-head-group d-flex align-items-center gap-2">
            
              <button
                className="btn btn-primary"
                onClick={() => {
                  if (refreshTableNumber == "") {
                    setRefreshTableNumber(true);
                  } else {
                    setRefreshTableNumber(!refreshTableNumber);
                  }
                  setOpenWithHeader(true);
                }}
              >
                {t("restaurant.table_management.btn_create_a_table")}
              </button>
              <button
                className="btn btn-primary"
                data-bs-target="#floorPlanModalToggle"
                data-bs-toggle="modal"
                onClick={() => { handleOpenFloorPlanModal() }}
              >
                {t("restaurant.table_management.btn_view_floor_plan")}
              </button>
            </div>
          </div>
          <div className="dashboard-content-wraper">
            <div className="category-list-wrap">
              {loader ? (
                <div className="w-100">
                  <Skeleton className="mb-2" height={50} count={5} />
                </div>
              ) : List?.length ? (
                <>
                  <div className="table-manage-wrap">
                    {List.map((item, index) => {
                      return (
                        <div className="table-card table-card-new" key={index}>
                          <div className="table-name ">
                            <div > {TrimText(item?.table_number, 5)}</div>
                          </div>

                          <div className="table-info-details">
                            <div className="ellipsis-text">
                              <span>{TrimText(t(`restaurant.table_management.${getLabelByValue(item.shape)}`) + ' ' + t("restaurant.table_management.label_shape"), 18)}</span>
                            </div>
                            <h4 className="ellipsis-text"> {item.capacity} {t("restaurant.table_management.label_guest")}</h4>
                          </div>

                          {item.is_available ? (
                            item?.is_reserved ? (
                              <span className="status-badge-for-table status-badge-danger">{t("restaurant.table_management.label_reserved")}</span>
                            ) : (
                              <span className="status-badge-for-table status-badge-success">{t("restaurant.table_management.label_available")}</span>
                            )
                          ) : (
                            <span className="status-badge-for-table status-badge-danger">{t("restaurant.table_management.label_occupied")}</span>
                          )}

                          <div className="dropdown">
                            <button className="btn-icon" type="button" data-bs-toggle="dropdown" aria-expanded="true"><i className="ti ti-dots-vertical"></i></button>
                            <ul className="dropdown-menu">
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => {
                                    getTableDetail(item);
                                  }}
                                  data-bs-toggle="offcanvas"
                                  data-bs-target="#view-table"
                                >
                                  <i className="ti ti-eye"></i>
                                  View
                                </button>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => {
                                    getTableDetail(item);
                                    setOpenWithHeaderEdit(true);
                                  }}
                                >
                                  <i className="ti ti-edit"></i>
                                  Edit
                                </button>
                              </li>
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => {
                                    deleteRecord(item);
                                  }}
                                >
                                  <i className="ti ti-trash"></i>
                                  Delete
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="table-status-info d-flex justify-content-between align-items-center mt-4">
                    <span>{t("restaurant.table_management.label_showing")} {offset + List.length} of {totalRecords} {t("restaurant.table_management.label_entries")}</span>
                    <nav aria-label="Page navigation example">
                      {totalRecords && totalRecords > 0 ?
                        <CustomPagination
                          datalength={totalRecords}
                          itemperpage={itemPerPage}
                          currentPage={page}
                          custompath="page"
                          setPage={setPage}
                          pageRoute={[{ name: "table-management", path: "/restaurant/table-management/table" }]} /> : ""
                      }
                    </nav>
                  </div>
                </>
              ) : (
                <RecordNotFound heading="restaurant.table_management.no_table_found" />
              )}
            </div>
          </div>
        </div>

        <div className="offcanvas offcanvas-end right-modal-w" id="view-table" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-modal="true" role="dialog">
          <div className="offcanvas-header">
            <h3 className="offcanvas-title" id="offcanvasRightLabel">
              {t("restaurant.table_management.label_view_details")}
            </h3>
            <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close">
              <i className="ti ti-x"></i>
            </button>
          </div>
          <div
            className="offcanvas-body"
            onScroll={(e) => {
              handleOffcanvasScroll(e, "view-table");
            }}
          >
            <div className="card">
              <div className="card-body">
                <div className="table-main-box">
                  <div className="table-name h-auto px-3" style={{ width: "auto" }}>{TrimText(tableDetail.table_number, 4)}</div>
                  <p>
                    {t("restaurant.table_management.number_of_guests_text")} {tableDetail.capacity}
                  </p>
                </div>
              </div>
            </div>

            <div className="view-staff-info mt-3">
              <div className="row gap-4">
                <div className="col-md-12">
                  <h4>{t("restaurant.table_management.table_shape_text")}</h4>
                  <p>{t(`restaurant.table_management.${getLabelByValue(tableDetail.shape)}`)}</p>
                </div>
                {generateQRUrl(tableDetail) ? (
                  <div className="col-md-12" id="qr-code">
                    <h4> {t("restaurant.table_management.label_qr_code")}</h4>
                    <figure
                      className="qr-code-img"
                      onClick={(e) => {
                        if (e.ctrlKey || e.metaKey) {
                          window.open(generateQRUrl(tableDetail), "_blank");
                        }
                      }}
                    >
                      <QRCodeSVG value={generateQRUrl(tableDetail)} id="qr-image" />
                    </figure>
                  </div>
                ) : null}
              </div>
            </div>

            {generateQRUrl(tableDetail) ? (
              <div className="row mt-3">
                <div className="col">
                  <ReactToPrint trigger={() => <button className="btn btn-primary w-100"> {t("restaurant.table_management.label_print_QR_code")}</button>} content={() => componentRef.current} />
                </div>
                <div className="col">
                  <button className="btn btn-primary w-100" onClick={(e) => handelDownload(tableDetail.table_number)}>
                    {t("restaurant.table_management.label_download")}
                  </button>
                </div>
              </div>
            ) : null}
          </div>
        </div>

        <Drawer open={openWithHeader}>
          <Drawer.Header closeButton={false}>
            <div className="d-flex justify-content-between w-100 align-items-center">
              <h3 className="mb-0">{t("restaurant.table_management.btn_create_a_table")}</h3>
              <button
                className="btn-icon"
                onClick={() => {
                  setOpenWithHeader(false);
                  addForm.resetForm();
                }}
              >
                <i className="ri-close-fill"></i>
              </button>
            </div>
          </Drawer.Header>
          <Drawer.Body
            onScroll={(e) => {
              handleOffcanvasScroll(e, "editNewEmail", "rsuite");
            }}
          >
            <form onSubmit={addForm.handleSubmit}>
              {/* Table Number */}
              <div className="mb-3">
                <label className="form-label">
                  {t("restaurant.table_management.label_table_number")}
                  <span>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("restaurant.table_management.placeholder_enter_table_number")}
                  value={newTableNumber}
                  disabled={true}
                />

              </div>

              {/* Capacity */}
              <div className="mb-3">
                <label className="form-label">
                  {t("restaurant.table_management.label_table_capacity")}
                  <span>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("restaurant.table_management.placeholder_enter_table_capacity")}
                  name="capacity"
                  value={addForm?.values?.capacity}
                  // onKeyDown={(e) => {
                  //   blockSpecialChar(e);
                  // }}
                  onChange={addForm.handleChange}
                  onBlur={addForm.handleBlur}
                />
                <CustomError name="capacity" form={addForm} className="text-danger" />
              </div>

              {/* Shape */}
              <div className="mb-3">
                <label className="form-label">
                  {t("restaurant.table_management.label_table_shape")}
                  <span>*</span>
                </label>
                <select className="form-control cp" name="shape" value={addForm.values.shape} onChange={addForm.handleChange} onBlur={addForm.handleBlur}>
                  <option value="" label={t("restaurant.table_management.placeholder_select_table_shape")} />
                  {TABLE_SHAPE_TYPES.map((item, index) => {
                    return (
                      <option key={index} value={item.value}>
                        {t(`restaurant.table_management.${item.label}`)}
                      </option>
                    );
                  })}
                </select>
                {addForm.touched.shape && addForm.errors.shape ? <div className="text-danger">{t(addForm.errors.shape)}</div> : null}
              </div>

              {/* Submit Button */}
              <div className="button-form">
                <button type="submit" className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")} formNoValidate>
                  {t("restaurant.button.btn_submit")}
                </button>
              </div>
            </form>
          </Drawer.Body>
        </Drawer>

        <Drawer open={openWithHeaderEdit}>
          <Drawer.Header closeButton={false}>
            <div className="d-flex justify-content-between w-100 align-items-center">
              <h3 className="mb-0">{t("restaurant.table_management.edit_table_label")}</h3>
              <button
                className="btn-icon"
                onClick={() => {
                  setOpenWithHeaderEdit(false);
                  editTableForm.resetForm();
                }}
              >
                <i className="ri-close-fill"></i>
              </button>
            </div>
          </Drawer.Header>
          <Drawer.Body
            onScroll={(e) => {
              handleOffcanvasScroll(e, "editEmail", "rsuite");
            }}
          >
            <form onSubmit={editTableForm.handleSubmit}>
              {/* Table Number */}
              <div className="mb-3">
                <label className="form-label">
                  {t("restaurant.table_management.label_table_number")}
                  <span>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("restaurant.table_management.placeholder_enter_table_number")}
                  value={editTableForm?.values?.table_number}
                  disabled={true}
                />
                <CustomError name="table_number" form={editTableForm} className="text-danger" />
              </div>

              {/* Capacity */}
              <div className="mb-3">
                <label className="form-label">
                  {t("restaurant.table_management.label_table_capacity")}
                  <span>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("restaurant.table_management.placeholder_enter_table_capacity")}
                  name="capacity"
                  value={editTableForm?.values?.capacity}
                  // onKeyDown={(e) => {
                  //   blockSpecialChar(e);
                  // }}
                  onChange={editTableForm.handleChange}
                  onBlur={editTableForm.handleBlur}
                />
                <CustomError name="capacity" form={editTableForm} className="text-danger" />
              </div>

              {/* Shape */}
              <div className="mb-3">
                <label className="form-label">
                  {t("restaurant.table_management.label_table_shape")}
                  <span>*</span>
                </label>
                <select className="form-control cp" name="shape" value={editTableForm.values.shape} onChange={editTableForm.handleChange} onBlur={editTableForm.handleBlur}>
                  <option value="" label={t("restaurant.table_management.placeholder_select_table_shape")} />
                  {TABLE_SHAPE_TYPES.map((item, index) => {
                    return (
                      <option key={index} value={item.value}>
                        {t(`restaurant.table_management.${item.label}`)}
                      </option>
                    );
                  })}
                </select>
                {editTableForm.touched.shape && editTableForm.errors.shape ? <div className="text-danger">{t(editTableForm.errors.shape)}</div> : null}
              </div>

              {/* Submit Button */}
              <div className="button-form">
                <button type="submit" className={"btn btn-primary w-100" + (editSubmissionLoader ? " btn-loader" : "")} formNoValidate>
                  {t("restaurant.button.btn_update")}
                </button>
              </div>
            </form>
          </Drawer.Body>
        </Drawer>
      </main>

      <div style={{ display: "none" }}>
        <div ref={componentRef} className="container d-flex justify-content-center align-items-center vh-100">
          <div className="text-center">
            <QRCodeSVG value={generateQRUrl(tableDetail)} height={400} width={400} className="mt-4" />
          </div>
        </div>
      </div>

      <div className="modal fade" id="floorPlanModalToggle" aria-hidden="true" aria-labelledby="floorPlanModalToggleLabel" tabIndex="-1" data-bs-backdrop="static">
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="floorPlanModalToggleLabel">Floor plan</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => {
                clearCanvas();
                setFloorTablesObj(null);
                setInitializeCanvas((prev) => !prev); // triggers re-init next time modal opens
              }}
              >
              </button>
            </div>
            <div className="modal-body" style={{
              minHeight: '60vh',
            }}>
              <div style={{
                backgroundImage: `
      repeating-linear-gradient(0deg, #eee, #eee 1px, transparent 1px, transparent 20px),
      repeating-linear-gradient(90deg, #eee, #eee 1px, transparent 1px, transparent 20px)
    `,
                backgroundSize: "20px 20px",
              }}>

                <canvas id='canvas' ref={canvasRef} />

              </div>
            </div>
            <div className="modal-footer">
              <div className="d-flex justify-content-end align-items-center">
                <button className="btn btn-primary d-none" data-bs-dismiss="modal" aria-label="Close" ref={floorPlanModalCloseBtn}>
                  Update
                </button>
                <button className="btn btn-primary" onClick={() => { handleCloseFloorPlanModal() }}>
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
